import { useContext, useEffect, useState } from "react";
import VerifyOTP from "../NewSignUp/VerifyOtp";
import CreatePin from "../Pincode/SetupPin/CreatePin";
import { useLocation, useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import Cookies from "js-cookie";
import { useSnackbar } from "../../../context/SnackbarContext";
import { RouteLeavingGuard } from "../../common";
import { LanguageContext } from "../../../context/LanguageContext";
import styles from "./styles.module.css";

const CompleteOnboarding = () => {
  const [isOtpVerified, setIsOptVerified] = useState(false);
  const [isDirty, setDirty] = useState(true);
  const [I18n] = useContext(LanguageContext);
  const [OTP, setOTP] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const phone = localStorage.getItem("phone_number");

  const handleSubmitPIN = async (data) => {
    setDirty(false);
    setTimeout(() => navigate("/Accounts"), 100);
  };

  useEffect(() => {
    // Check if location.state exists and clear it on page reload
    if (location?.state?.isCompleteOnboarding) {
      // Replace the current history entry to clear the location state
      navigate(location.pathname, {
        replace: true,
        state: { sendOTPResponse: location?.state?.sendOTPResponse },
      });
    }
  }, [location]);

  useEffect(() => {
    if (!location?.state?.isCompleteOnboarding) {
      navigate("/Accounts");
    }
  }, []);

  return (
    <Box className={`${styles.completeOnboardingContainer}`}>
      {!isOtpVerified ? (
        <VerifyOTP
          phone={phone}
          sendOTPResponse={location?.state?.sendOTPResponse}
          handleVerifyOTP={(data) => setIsOptVerified(data?.success)}
          setOTP={setOTP}
          userId={Cookies.get("tempUserId")}
          isSignup={true}
          isShowRightCta={false}
        />
      ) : (
        <CreatePin
          handleCancel={() => {
            navigate(-1);
          }}
          userId={Cookies.get("tempUserId")}
          handleSetPINSuccess={handleSubmitPIN}
          phone={phone}
        />
      )}

      <RouteLeavingGuard
        when={isDirty}
        confirmText={"Yes"}
        title={!isOtpVerified ? I18n.OTP_verification_required : I18n.PIN_is_required}
        message={!isOtpVerified ? I18n.You_cant_leave_otp_verify_message : I18n.you_cannot_leave_this_page_without_creating_a_PIN}
        isConfirmBtn={false}
      />
    </Box>
  );
};
export default CompleteOnboarding;
